/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvalidationcontingentonlygrows4Inputs */

const en_dropvalidationcontingentonlygrows4 = /** @type {(inputs: Dropvalidationcontingentonlygrows4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A running drop’s contingent can only grow.`)
};

const de_dropvalidationcontingentonlygrows4 = /** @type {(inputs: Dropvalidationcontingentonlygrows4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei einem laufenden Drop kann das Kontingent nur wachsen.`)
};

/**
* | output |
* | --- |
* | "A running drop’s contingent can only grow." |
*
* @param {Dropvalidationcontingentonlygrows4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvalidationcontingentonlygrows4 = /** @type {((inputs?: Dropvalidationcontingentonlygrows4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvalidationcontingentonlygrows4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvalidationcontingentonlygrows4(inputs)
	return de_dropvalidationcontingentonlygrows4(inputs)
});
export { dropvalidationcontingentonlygrows4 as "dropValidationContingentOnlyGrows" }